<template>
  <div class="container">
    <head-nav-bar title="会员类型" :fixed="true"> </head-nav-bar>
    <div class="mt-header-nav">
      <van-search
        placeholder="请输入搜索关键词"
        style="border-bottom:1px solid #f1f1f1;"
        v-model="keyword"
        @search="onSearch"
        shape="round"
        show-action
      >
        <template #action>
          <div @click="onSearch">搜索</div>
        </template>
      </van-search>
      <data-list
        :api="getMemberTypeList"
        :params="listParams"
        style="height:calc(100vh - 115px)"
      >
        <template v-slot:item="item">
          <!-- <van-swipe-cell style="min-height:66px;"> -->
          <van-cell :title="item.Name" is-link @click="toInfo(item)">
            <template #label>
              <div>
                <van-tag v-if="item.Status == '1'" type="success">启用</van-tag>
                <van-tag v-else type="danger">禁用</van-tag>
                {{ item.Code }}
              </div>
            </template>
          </van-cell>
          <!-- <template slot="right">
              <van-button
                square
                :type="item.Status == '1' ? 'danger' : 'success'"
                style="height:100%;"
                :text="item.Status == '1' ? '禁用' : '启用'"
                @click="setStatus(item)"
              />
            </template>
          </van-swipe-cell> -->
        </template>
      </data-list>
    </div>
  </div>
</template>

<script>
import { getMemberTypeList } from "@/api/member.js";

import { SwipeCell, Button, Search, Tag, Cell } from "vant";
import DataList from "@/components/DataList";

export default {
  components: {
    [SwipeCell.name]: SwipeCell,
    [Button.name]: Button,
    [Search.name]: Search,
    [Tag.name]: Tag,
    [Cell.name]: Cell,
    DataList,
  },
  data() {
    return {
      getMemberTypeList,
      listParams: {},
      keyword: "",
      memberTypeData: [],
      memberStatusData: [],
    };
  },
  created() {},
  methods: {
    toInfo(item) {
      this.$router.push({
        name: "memberTypeInfo",
        query: {
          Id: item.Id,
        },
      });
    },
    onSearch() {
      this.listParams = {
        Keyword: this.keyword,
      };
    },

    handleSearch(/*values*/) {
      // console.log(values);
    },
    setStatus(/*item*/) {
      // console.log(item);
      // delMember({
      //   Id: item.Id
      // }).then(res => {
      //   this.onSearch();
      // });
    },
  },
};
</script>
